import classNames from "../../utils/classNames";
import { stateLabel, stateTone, StateTone } from "../../utils/returnsRules";

const toneClasses: Record<StateTone, string> = {
  amber: "bg-amber-100 text-amber-700",
  green: "bg-green-100 text-green-700",
  red: "bg-red-100 text-red-700",
  grey: "bg-gray-100 text-gray-700",
};

interface StateChipProps {
  state: string | null | undefined;
  /** The API's label when it has one; otherwise the spec's mapping is used. */
  label?: string | null;
  className?: string;
}

/** eBay's state in eBay's words. A manual return (no eBay state) gets a dashed outline instead. */
export default function StateChip({ state, label, className }: StateChipProps) {
  if (!state) {
    return <span className={classNames("whitespace-nowrap rounded border border-dashed border-gray-300 px-[7px] py-0.5 text-[11px] text-gray-500", className)}>{stateLabel(null)}</span>;
  }
  return <span className={classNames("whitespace-nowrap rounded px-[7px] py-0.5 text-[11px] font-semibold", toneClasses[stateTone(state)], className)}>{label || stateLabel(state)}</span>;
}
